import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">为什么选我们</h2>
          <p className="mt-2 text-sm text-foreground-600">四大核心优势打造最值得信赖的爆料平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6 hover:border-primary-200 transition-colors group"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}